import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
export var useItemSort = function useItemSort() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      sortAttribute = _useState4[0],
      setSortAttribute = _useState4[1];

  return {
    sortDirection: sortDirection,
    setSortDirection: setSortDirection,
    sortAttribute: sortAttribute,
    setSortAttribute: setSortAttribute
  };
};